'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = create;
function create() {
    var fixture = { type: 'delivery' };

    return {
        setArea: function setArea(area) {
            fixture.area = area;
            return this;
        },
        setMinOrderPrice: function setMinOrderPrice(val) {
            fixture.minOrderPrice = val;
            return this;
        },
        setCharge: function setCharge(val) {
            fixture.charge = val;
            return this;
        },
        setDelayMins: function setDelayMins(val) {
            fixture.delayMins = val;
            return this;
        },
        setInactive: function setInactive(val) {
            fixture.inactive = val;
            return this;
        },
        setAvailability: function setAvailability(val) {
            fixture.availability = val;
            return this;
        },
        val: function val() {
            return fixture;
        }
    };
}